"use client";

import { LetterPurple } from "@/icons/letter-purple";
import { useTranslations } from "next-intl";
import BizeYazinForm from "../bize-yazin-form";

export default function BizeYazin() {
    const t = useTranslations("helpContent");

    return (
        <div className="mt-6 mb-8 flex w-full rounded-md py-3 lg:mt-8">
            <div className="flex w-full flex-row">
                <div key={1} className="w-2/5 rounded-md bg-violet-300 p-8">
                    <h2 className="text-left text-3xl font-semibold text-white">
                        {t("contactTitle")}
                    </h2>
                    <p className="text-primary-pressed mt-2 mb-8 text-left">
                        {t("contactBody")}
                    </p>
                    <LetterPurple
                        aria-hidden="true"
                        className="mx-auto w-[60%]"
                        width={137}
                        height={120}
                    />
                </div>
                <div key={2} className="w-3/5 rounded-md bg-white p-16">
                    <BizeYazinForm />
                </div>
            </div>
        </div>
    );
}
